import { omit } from "lodash";

export const flattenVariables = ({
  variables,
  excludeRegion = true,
}: {
  variables: {
    [key: string]: unknown;
  };
  excludeRegion?: boolean;
}) => {
  const flattenTarget = excludeRegion ? omit(variables, "regionId") : variables;
  return Object.entries(flattenTarget)
    .filter(([, value]) => Boolean(value))
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map((v) => ({
          [key]: v,
        }));
      }

      return {
        [key]: value,
      };
    })
    .flat();
};
